export default __webpack_public_path__ + "static/media/Ct1.e3101cb3.png";